import { render } from "./Actionable.vue?vue&type=template&id=222d7820&scoped=true&ts=true"
import script from "./Actionable.vue?vue&type=script&lang=ts"
export * from "./Actionable.vue?vue&type=script&lang=ts"

import "./Actionable.vue?vue&type=style&index=0&id=222d7820&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-222d7820"]])

export default __exports__